module.exports = __webpack_public_path__ + "static/img/adwords.5f2dad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/adwords.jpg
// module id = hmQ0
// module chunks = 0